<div class="contract-wrapper">
<table style="width: 100%;" border="0px">
  <tbody id="fordImage">
    <tr>
      <td>

        <div style="text-align: center;">

          <img style="width: 380px; height: 80px;" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="">
        </div>

        <div class="title-terminos">

          <h5 class="title-padding">
            TÉRMINOS Y CONDICIONES DEL PLAN DE MANTENCÍON PREPAGO FORD PROTECT
          </h5>
        </div>

      </td>
    </tr>
  </tbody>
</table>

<div>
  <article class="article">

    <p class="text-initial">
      En Santiago de Chile, a {{contractSignature.salesDate | date:"dd/MM \'de\' yyyy" }} comparece,
      (en adelante, el "<span class="span-underlined">Cliente</span>" o el "<span
        class="span-underlined">Contratante</span>"); y <span class="span-negrito">FORD MOTOR COMPANY CHILE SpA,</span>
      RUT N° 78.703.910-3, con domicilio para estos efectos en calle Enrique Foster Sur 20, piso 11, comuna de Las Condes, Santiago, (en adelante, 
      "<span class="span-underlined">Ford</span>" y conjuntamente con el Cliente como las "<span class="span-underlined">Partes</span>"o, individualmente cada una de ellas como la "<span
        class="span-underlined">Parte</span>"), acuerdan celebrar el presente acuerdo, en adelante el "<span class="span-underlined">Contrato</span>".
    </p>

    <h5 class="sub-title title-negrito">CONSIDERANDOS:</h5>

    <div class="m-5">
      <ol class="custom-list-roman">
        <li class="li-roman">
          El Cliente ha comprado el vehículo Ford, modelo {{ contractSignature.modelYearLine }}, en adelante, el "<span class="span-underlined">Vehículo</span>";
        </li>
        <li class="li-roman">
          Mediante el presente Contrato, Ford ofrece a sus clientes la
          posibilidad de comprar planes de mantención, según estos se
          definen en la siguiente Cláusula Primera del Contrato;
        </li>
        <li class="li-roman">
          Bajo los términos de dichos planes (término definido a
          continuación), los servicios de mantención serán realizados
          por los concesionarios de Ford autorizados dentro del territorio
          nacional (en adelante, el o los "<span class="span-underlined">Concesionarios Ford</span>").
        </li>
      </ol>
    </div>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA PRIMERA</span>: PLANES.
    </h5>

    <ol class="custom-list-number">
      <li class="li-number">
        Los planes que ofrece Ford y que el Cliente puede elegir
        alternativamente son los siguientes, en adelante, todos
        conjuntamente como los "<span class="span-underlined">Planes</span>":
        <ul class="ul-ifem">
          <li class="li-ifem">
            <span class="span-negrito">Ford Protect Duo 1</span>: incluye las primeras dos (2)
            revisiones de mantención del Vehículo;            
          </li>
          <li class="li-ifem">
            <span class="span-negrito">Ford Protect Blue 1</span>: incluye las primeras tres (3) revisiones
            de mantención del Vehículo.
          </li>
        </ul>
      </li>
      <li class="li-number">
        Es obligación del Cliente el ingreso del Vehículo al Concesionario
        Ford de su elección para realizar las revisiones de mantención
        periódicas dentro de los intervalos definidos, y esencial para el
        funcionamiento correcto y seguro del mismo, así como para
        garantizar el mejor rendimiento y durabilidad del Vehículo.
      </li>
      <li class="li-number">
        Las revisiones contratadas, hacen parte del Programa de
        Mantención Preventivo Ford, y deben ser realizadas conforme
        al intervalo de tiempo y/o kilometraje (km) o a indicación del
        “Monitor Inteligente de Vida del Aceite” ("<span class="span-underlined">IOLM</span>"), si el Vehículo
        viene equipado con éste, en cualquier caso, lo que ocurra
        primero, según se indica en la tabla de Mantención de la “Guía de Servicio Ford” (en adelante, “Guía de
        Servicio Ford”). Para todos los efectos del Contrato, se deja constancia que se hizo
        entrega al Cliente del Manual del Propietario. De acuerdo con lo
        indicado en el Plan, según la revisión respectiva que corresponda,
        las operaciones incluidas serán: el cambio de aceite de motor,
        filtro de aceite, filtro de aire, filtro de combustible, filtro de
        cabina, fluido de frenos, limpiador de frenos y líquido
        limpiabrisas. También incluyen la mano de obra para todas las
        inspecciones y controles previstos.
      </li>
      <li class="li-number">
        Como se establece en el Manual del Propietario, la tolerancia
        máxima para realizar revisiones periódicas es de (1) mes a 1.000
        km.
      </li>
      <li class="li-number">
        Las operaciones deben llevarse a cabo de acuerdo con lo descrito
        en cada revisión.
      </li>
      <li class="li-number">
        Si existe necesidad de sustitución o reparación
        de piezas distintas a las indicadas en el Plan o los Planes, un asesor
        de servicio del Concesionario Ford se comunicará prontamente
        con el Cliente.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA SEGUNDA</span>: USO DEL PLAN.
    </h5>

    <ol class="custom-list-number">
      <li class="li-number">
        Para la ejecución del Plan contratado, el Cliente deberá escoger el
        Concesionario Ford de su preferencia y agendar la cita del
        servicio. La lista de concesionarios Ford se puede encontrar en el
        sitio web <a class="a-edit" href="http://www.ford.cl" target="_blank" rel="noopener noreferrer">www.ford.cl</a>.
      </li>
      <li class="li-number">
        El tiempo de prestación del servicio por parte del Concesionario
        Ford elegido puede variar de acuerdo con el flujo de servicios en
        curso en la fecha programada por el Cliente.
      </li>
      <li class="li-number">
        Ford no es responsable y no reconocerá ningún costo y/o gasto
        incurrido en (i) servicios realizados fuera de los Concesionarios
        Ford autorizados en el territorio nacional, (ii) servicios prestados
        fuera del alcance estricto previsto en este Contrato.
      </li>
      <li class="li-number">
        En caso de dudas sobre los servicios y productos recomendados
        para el mantención del Vehículo, el Cliente podrá consultar la
        Guía de Servicio Ford y el Manual de Propietario.
      </li>
      <li class="li-number">
        El Plan está vinculado al número de chasis del Vehículo. Por lo
        anterior, el tercero que adquiera el Vehículo del Cliente podrá
        realizar los servicios restantes aún no realizados en el Plan,
        siempre y cuando el Contrato este vigente y se respeten los
        intervalos de tiempo y kilómetros (km) recorridos. Como
        contrapunto, en caso de robo, hurto o pérdida total del Vehículo
        se pierde el plan también.
      </li>
      <li class="li-number">
        El Cliente que no realice alguno de los servicios previstos en el
        Plan dentro del Período de Vigencia de este Contrato y de acuerdo
        con los intervalos de tiempo y kilómetros (km) recorridos
        establecidos, y las alertas de IOLM, no podrá realizar dichos
        servicios no realizado oportunamente fuera del período
        estipulado. Los servicios posteriores que estén cubiertos en el
        Plan contratado podrán realizarse normalmente.
      </li>
      <li class="li-number">
        Independientemente de la contratación del Plan y respectivo
        pago anticipado por las piezas y servicios contratados, la no
        realización de alguna de las revisiones previstas en el Plan segúnlos intervalos de tiempo, kilómetros (km)
        recorridos o indicación
        del IOLM (si está equipado con este) establecido en este Contrato,
        y, así mismo, la no realización de revisiones periódicas tras la
        finalización del Plan, de acuerdo con los intervalos de tiempo y
        kilómetros (km) según la “Guía de Servicio Ford” del Vehículo,
        puede causar la cancelación de la garantía del Vehículo.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA TERCERA</span>: PRECIO.
    </h5>

    <ol class="custom-list-number">
      <li class="li-number">
        En el precio del Plan contratado se incluye la mano de obra y
        repuestos de las operaciones a realizar en los intervalos de tiempo
        y kilómetros (km) según lo recomendado en la “Guía de Servicio
        Ford” para el Programa de Mantención Preventivo Ford. Se
        entiende que cualquier operación o pieza adicional no
        contemplada en este Contrato, debe pagarse por separado
        directamente al Concesionario Ford donde se está realizando el
        servicio de mantención.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA CUARTA</span>: VIGENCIA.
    </h5>

    <ol class="custom-list-number">
      <li class="li-number">
        El presente Contrato entrará en vigor a partir de la fecha de
        emisión de la factura de venta del Vehículo, por los siguientes
        períodos:
        <ol class="custom-list-alphabet" type="a">
          <li class="li-alphabet">
            <span class="span-negrito">Ford Protect Duo 1</span>: 24 (veinticuatro) meses o al
            alcanzar el kilometraje máximo programado de 32,000 km o
            cuando el indicador de OILM lo indique, lo que ocurra
            primero ("<span class="span-underlined">Periodo de Término</span>");
          </li>
          <li class="li-alphabet">
            <span class="span-negrito">Ford Protect Blue 1</span>: 36 (treinta y seis) meses o al alcanzar el
            kilometraje máximo programado de 48,000 km o cuando el
            indicador de OILM lo indique, lo que ocurra primero
            ("<span class="span-underlined">Período de Término</span>").
          </li>
        </ol>
      </li>
      <li class="li-number">
        El inicio de la vigencia del Contrato y la respectiva activación del
        Plan estarán condicionados al pago total del precio establecido.
      </li>
      <li class="li-number">
        En ningún caso se prorrogará la vigencia del Contrato.
      </li>
      <li class="li-number">
        El Cliente entiende que, para satisfacer las demandas del Plan,
        Ford realizará inversiones para mantener la calidad de sus
        servicios y con el calendario de revisión del Vehículo.
      </li>
      <li class="li-number">
        Si el Contratista <span class="span-negrito">se retira del Plan no tendrá derecho ningún tipo
          de reembolso.</span>
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA QUINTA</span>: ATENCIÓN.
    </h5>

    <ol class="custom-list-text custom-list-number">
      <li class="li-text">
        Ford se obliga a proporcionar al Cliente canales de servicio para
        resolver sus dudas, sugerencias y quejas sobre el Plan.
      </li>
      <li class="li-text">
        Para estos efectos, el Cliente deberá comunicarse mediante la
        siguiente línea de atención al +56-800-719-061.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA SEXTA</span>: OTRAS OBLIGACIONES DEL CLIENTE.
    </h5>
    <ol class="custom-list-number">
      <li class="li-number">
        El Cliente se compromete a realizar las revisiones periódicas de
        mantención y a seguir todas las recomendaciones, cuidados y
        comprobaciones adicionales que se indiquen en el Manual de
        Propietario y/o Guía de Servicio Ford.
      </li>
      <li class="li-number">
        El Cliente se compromete a mantener actualizados sus datos
        personales de contacto (nombre completo, número de
        identificación, correo electrónico, teléfonos de contacto,
        dirección) llamando a la línea de atención Ford para posibilitar
        futuros contactos de Ford estrictamente relacionados con este
        contrato.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA SÉPTIMA</span>: ANTICORRUPCIÓN.
    </h5>
    <ol class="custom-list-number">
      <li class="li-number">
        El Cliente declara que conoce y comprende los términos del
        Código Penal Chileno, Ley 20.393, Ley 21.121 y de cualquier otra
        ley aplicable sobre el tema de este Contrato, incluida, entre otras,
        la ley estadounidense llamada Ley de Prácticas Corruptas en el
        Extranjero de los Estados Unidos de América (Foreign Corrupt
        Practice Act FCPA) y la UK Bribery Act ("<span class="span-underlined">Reglas Anticorrupción</span>"),
        comprometiéndose a abstenerse de cualquier actividad que
        constituya una violación de las disposiciones de las Reglas
        Anticorrupción.
      </li>
      <li class="li-number">
        Cualquier incumplimiento de las Reglas Anticorrupción por parte
        del Cliente, en cualquiera de sus aspectos, dará lugar a la
        terminación inmediata de este instrumento,
        independientemente de cualquier notificación, sujeto a las
        sanciones previstas en este Contrato, así como a la
        responsabilidad de la parte incumplidora de indemnizar a la parte
        perjudicada por cualquier daño derivado del incumplimiento de
        las Reglas Anticorrupción.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA OCTAVA</span>: Caso Fortuito o Fuerza Mayor.
    </h5>
    <ol class="custom-list-number">
      <li class="li-number">
        Las Partes quedarán exento de toda responsabilidad respecto del
        cumplimiento cabal e íntegro del Contrato, si durante su vigencia,
        se verifique un hecho constitutivo de fuerza mayor.
      </li>
      <li class="li-number">
        Para los efectos de la interpretación de la presente cláusula, se
        entenderá por “Caso Fortuito” o “Fuerza Mayor” lo establecido
        en el artículo 45 del Código Civil Chileno, y en especial las
        siguientes situaciones, señaladas de forma meramente
        enunciativa y no taxativa: actos de autoridad, revolución, guerra,
        disturbios públicos nacionales o locales, inundación, demoras o
        desviaciones logísticas relevantes en origen, trayecto o destino,
        boycott internacional, huelga, actos terroristas, cierre de puertos,
        aeropuertos y/o cualquier tipo de puntos de embarcación (sean
        parciales, temporales o definitivas), cierre de fronteras por la autoridad nacional o internacional, cierre de
        aduanas o
        restricciones en la misma o en general que alteran sustancialmente la prestación de los servicios a los que se
        obliga Ford en virtud de este Contrato.
      </li>
    </ol>

    <h5 class="sub-title title-negrito">
      <span class="span-underlined">CLÁUSULA NOVENA</span>: Datos Personales.
    </h5>

    <ol class="custom-list-text custom-list-number">
      <li class="li-text">
        Para efectos de los datos personales del Cliente, aplica la política de
        Ford disponible en <a class="a-edit-blue" href="http://www.ford.cl" target="_blank"
          rel="noopener noreferrer">www.ford.cl</a>, las cuales en ningún caso contraviene
        la ley N° 19.628 y sus posibles modificaciones.
      </li>
      <li class="li-text">
        Cualquier comunicación sobre el Plan contratado se realizará a través
        de la línea de atención Ford.
      </li>
    </ol>

  </article>

</div><!-- /.article-div -->
</div><!-- /.contract-wrapper -->